import { ReactNode, createContext, useContext } from 'react';
import { useMemoizedArray } from '../hooks/use-memoized-array';

export interface SelectedLocationProviderProps {
  children: ReactNode;
  locationId: string | undefined | (string | undefined)[];
}

export const selectedLocationContext = createContext<string[] | undefined>(undefined);

export const SelectedLocationProvider = ({ children, locationId }: SelectedLocationProviderProps) => {
  const locationIds = useMemoizedArray(locationId);

  return <selectedLocationContext.Provider value={locationIds}>{children}</selectedLocationContext.Provider>;
};

export const useSelectedLocations = () => {
  const locationIds = useContext(selectedLocationContext);
  if (!locationIds) {
    throw new Error('useSelectedLocations must be used within a SelectedLocationProvider');
  }
  return {
    locationIds,
  };
};

export const useSelectedLocation = () => {
  const locationIds = useContext(selectedLocationContext);
  if (!locationIds) {
    throw new Error('useSelectedLocation must be used within a SelectedLocationProvider');
  }
  return locationIds[0];
};
